import { render, staticRenderFns } from "./VideoWall.vue?vue&type=template&id=279f4034&scoped=true"
import script from "./VideoWall.vue?vue&type=script&lang=js"
export * from "./VideoWall.vue?vue&type=script&lang=js"
import style0 from "./VideoWall.vue?vue&type=style&index=0&id=279f4034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f4034",
  null
  
)

export default component.exports